// Banner modal central para atualização do PWA

interface UpdateBannerProps {
  onUpdate: () => void;
  onDismiss?: () => void;
}

export default function UpdateBanner({ onUpdate, onDismiss }: UpdateBannerProps) {
  // Estilo minimalista: overlay central com card azul no padrão do app
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Atualização disponível"
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.35)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <div
        style={{
          width: 'min(92vw, 480px)',
          borderRadius: 12,
          background: '#0d6efd',
          color: 'white',
          boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
          padding: '20px 18px 16px 18px',
          position: 'relative',
        }}
      >
        {onDismiss && (
          <button
            aria-label="Fechar"
            onClick={onDismiss}
            style={{
              position: 'absolute',
              top: 8,
              right: 10,
              background: 'transparent',
              border: 'none',
              color: 'white',
              fontSize: 20,
              cursor: 'pointer',
              lineHeight: 1,
            }}
          >
            ×
          </button>
        )}

        <div style={{ marginBottom: 10, fontWeight: 600, fontSize: 18 }}>
          Nova versão disponível
        </div>
        <div style={{ opacity: 0.95, marginBottom: 16 }}>
          Para obter as últimas melhorias, atualize agora.
        </div>

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          {onDismiss && (
            <button
              onClick={onDismiss}
              style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                border: 'none',
                padding: '10px 14px',
                borderRadius: 8,
                cursor: 'pointer',
              }}
            >
              depois
            </button>
          )}
          <button
            onClick={onUpdate}
            style={{
              background: 'white',
              color: '#0d6efd',
              border: 'none',
              padding: '10px 14px',
              borderRadius: 8,
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            Atualizar Agora?
          </button>
        </div>
      </div>
    </div>
  );
}
